import React, { FC }    from "react";
import { useDispatch }  from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import RouterDispatcher from "../../../../infrastructure/redux/router/RouterDispatcher";

const RecordTemplateAddButton: FC = () => {
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => routerDispatcher.recordTemplateRegister() }
      >
        <Icon name="plus"/>記録テンプレートを新規作成する
      </Button>
    </>
  )
};

export default RecordTemplateAddButton;
